import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { NewCustomerBillerInfoSnackBarData } from '../../models/new-biller-snack-bar.model';
import { Crisp } from 'crisp-sdk-web';

@Component({
standalone: false,
  selector: 'app-new-customer-biller-info-snack-bar',
  templateUrl: './new-customer-biller-info-snack-bar.component.html',
  styleUrls: ['./new-customer-biller-info-snack-bar.component.css'],
})
export class NewCustomerBillerInfoSnackBarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<NewCustomerBillerInfoSnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: NewCustomerBillerInfoSnackBarData,
  ) {}

  public openChat(): void {
    if (typeof Intercom !== 'undefined') {
      Intercom('showNewMessage');
    }

    if (window['$crisp']) {
      Crisp.chat.open();
    }
  }
}
